import { Menu, MenuItem, MenuState } from '@vtex/admin-ui'
import { GenericIcon } from 'typings'
import { NestedMenu } from 'ui'
import { SelectedItem } from '../BenefitSelector/SelectedItem'
import styles from './styles.css'

export type Option = {
  name: string
  label: JSX.Element
  sectionLabel?: JSX.Element
  Icon: GenericIcon
  children?: Array<Option>
}

export type Options = Array<Option>

type Props = {
  state: MenuState
  onAdd: (name: string) => void
  options: Options
  selected?: string
}

export function MenuLabel({
  label,
  isSelected,
}: {
  label: JSX.Element
  isSelected: boolean
}) {
  return isSelected ? <SelectedItem name={label} /> : label
}

export function BenefitMenu(props: Props) {
  const { state, onAdd, options, selected } = props

  return (
    <Menu state={state}>
      {options.map(({ name, label, Icon, children }) => (
        <>
          {children ? (
            <NestedMenu key={name} label={label} icon={<Icon />}>
              {children.map(
                ({ name: childName, label: childLabel, Icon: ChildIcon }) => (
                  <MenuItem
                    key={childName}
                    label={
                      <MenuLabel
                        label={childLabel}
                        isSelected={childName === selected}
                      />
                    }
                    icon={<ChildIcon />}
                    onClick={() => onAdd(childName)}
                    aria-current={childName === selected}
                    className={styles.menuItem}
                  />
                )
              )}
            </NestedMenu>
          ) : (
            <MenuItem
              key={name}
              label={<MenuLabel label={label} isSelected={name === selected} />}
              icon={<Icon />}
              onClick={() => onAdd(name)}
              aria-current={name === selected}
              className={styles.menuItem}
            />
          )}
        </>
      ))}
    </Menu>
  )
}
